/**
 * La règle unique des montants signés (QF-006) : un chiffre signé n'est
 * **jamais** coloré par son signe — le « − » suffit à le lire. Le vert,
 * l'orange et le rouge restent réservés aux statuts (`nombre--succes`,
 * `nombre--alerte`, pastilles). Un montant non nul garde seulement le gras,
 * pour se repérer dans une colonne de zéros.
 */
export function classeMontant(valeur: string): string {
  const nombre = Number(valeur);
  return Number.isFinite(nombre) && nombre !== 0 ? 'nombre nombre--fort' : 'nombre';
}
